// Stripe keys
let pkKeys = {
    s: 'pk_live_22HdDuvIOJ715uUQ59wBCKAi', // Stripe LP
};

// Setting test keys for non prod environements
if (typeof (window.lp_env) === 'string' && window.lp_env !== 'prod') {
    pkKeys = {
    s: 'pk_test_pHVAlJpIbJfYc9EJp7zEYwcL',
    };
}

var stripe = Stripe(pkKeys.s);

function stripeElement() {

        
        var style = {
            base: {
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4'
            },
            ':-webkit-autofill': {
                color: '#32325d',
            },
            },
            invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
            ':-webkit-autofill': {
                color: '#fa755a',
            },
            }
        }
        
        var elements = stripe.elements();
        var iban = elements.create('iban', {
            style: style,
            supportedCountries: ['SEPA'],
        });

        return iban;
}

export {stripeElement, stripe};


// WEBPACK FOOTER //
// ./src/components/utils/stripe_element.js